import { useTranslation } from 'react-i18next';
import type { BadgeVariant } from '@/components/ui/badge';
import { CalibrationSessionState } from '../../__generated__/graphql';

type StateBadge = {
  label: string;
  bg: BadgeVariant;
};

export const useCalibrationSessionStateBadge = (
  state: CalibrationSessionState | undefined,
): StateBadge => {
  const { t } = useTranslation();

  switch (state) {
    case CalibrationSessionState.InProgress:
      return {
        label: t('performanceReview.calibration.state.inProgress'),
        bg: 'primary',
      };
    case CalibrationSessionState.Finished:
      return {
        label: t('performanceReview.calibration.state.finished'),
        bg: 'secondary',
      };
    default:
      return {
        label: '',
        bg: 'secondary',
      };
  }
};
